import * as getters from "../../baseQuestion/searchableDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableDDL/store/actions";
import { state as base_state } from "../../baseQuestion/searchableDDL/store/state";

function state() {
	return Object.assign(
		{
			option_source_dependent: "q_umfk_major_2",
			option_source_dependent_filter_key: "acadPlan",
			option_source: {
				type: "concentration",
				filter: [
					{
						operand: "institution",
						operator: "=",
						argument: "UMS03"
					}
				]
			}
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
